<template>
  <div class="main">
    <div class="title">用户登录</div>
    <div class="login-area">
      <div class="avatar-area">
        <img src="../assets/dongti/login-avatar.png" />
      </div>
      <div class="right">
        <a-form :form="form" @submit.prevent="handleSubmit" autocomplete="off">
          <a-form-item label="用户名" :validate-status="usernameError() ? 'error' : ''" :help="usernameError() || ''">
            <a-input v-decorator="['username', { rules: [{ required: true, message: '请输入用户名。' }] }]" placeholder="请填写用户名">
              <a-icon slot="prefix" type="user" style="color: rgba(0, 0, 0, 0.25)" />
            </a-input>
          </a-form-item>
          <a-form-item label="密码" :validate-status="passwordError() ? 'error' : ''" :help="passwordError() || ''">
            <a-input
              v-decorator="['password', { rules: [{ required: true, message: '请输入密码。' }] }]"
              type="password"
              placeholder="请填写密码"
            >
              <a-icon slot="prefix" type="lock" style="color: rgba(0, 0, 0, 0.25)" />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" html-type="submit" :disabled="hasErrors(form.getFieldsError())"> 登 录 </a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { HOME_PAGE, ACCESS_TOKEN } from '@/store/mutation-types'
import CryptoJS from 'crypto-js'

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field])
}

export default {
  beforeRouteEnter(to, from, next) {
    let token = localStorage.getItem(ACCESS_TOKEN)
    if (token) {
      next(HOME_PAGE)
    } else {
      next()
    }
  },
  data() {
    return {
      hasErrors,
      form: this.$form.createForm(this, { name: 'horizontal_login' }),
    }
  },
  mounted() {
    this.$nextTick(() => {
      // To disabled submit button at the beginning.
      this.form.validateFields()
    })
    let key = localStorage.getItem('auth_key')
    key = key.split(' ').join('+')

    if (key) {
      key = this.decryptDES(key)

      const auth = key.split('&')

      const obj = {}
      auth.forEach((row) => {
        const arr = row.split('=')
        obj[arr[0]] = arr[1]
      })

      this.form.setFieldsValue({
        username: obj.user,
        password: obj.password,
      })
    }
  },
  methods: {
    decryptDES(ciphertext) {
      const key = 'move2015'
      const keyHex = CryptoJS.enc.Utf8.parse(key)

      if (ciphertext) {
        let decrypted = CryptoJS.DES.decrypt(ciphertext, keyHex, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7,
        })

        return decrypted.toString(CryptoJS.enc.Utf8)
      } else {
        return ''
      }
    },
    ...mapActions(['Login']),
    usernameError() {
      const { getFieldError, isFieldTouched } = this.form
      return isFieldTouched('username') && getFieldError('username')
    },
    // Only show error after a field is touched.
    passwordError() {
      const { getFieldError, isFieldTouched } = this.form
      return isFieldTouched('password') && getFieldError('password')
    },
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.Login(values).then((r) => {
            if (r.code * 1 === 200) {
              if (r.data.dashboard) {
                this.$nextTick(() => {
                  this.$router.replace({ path: HOME_PAGE })
                })
              } else {
                this.$message.error({
                  title: '提示',
                  content: '暂无权限',
                })
              }
            } else {
              this.$modal.error({
                title: '提示',
                content: r.message,
              })
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.main {
  background: url(../assets/dongti/login.jpg) no-repeat center center/100% 100%;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #fff;
  flex-direction: column;
  /deep/ .ant-form-item-label > label {
    color: #fff;
  }
  .title {
    color: #00cbff;
    font-size: 42px;
    margin-top: 200px;
  }
  .login-area {
    background: url(../assets/dongti/login-border.png) no-repeat center center/100% 100%;
    width: 650px;
    height: 400px;
    margin-top: 28px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 80px;
    .avatar-area {
      width: 250px;
      height: 250px;
      margin-right: 20px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
